import { getAPIPath } from '@interhyp/platform-request';
import fetchWrapper, { getConnection } from '@interhyp/util-request';
import ApolloClient, { gql } from 'apollo-boost';
import { Dispatch } from 'redux';
import { ThunkAction } from 'redux-thunk';

import { MandantConfigState } from '../MandantConfigState';
import { setData, setLoading, setTranslation } from '../actions';
import { gup } from '../functions/gup';

// todo extract from utils-request
const getCookie = (name: string) => {
  // eslint-disable-next-line require-unicode-regexp
  const result = new RegExp(`(^|;) ?${name}=([^;]*)(;|$)`).exec(document.cookie);
  return result ? decodeURIComponent(result[2]) : null;
};

// Only use interhyp as fallback for local development
const tenantFallback = window.location.hostname === 'localhost' ? 'interhyp' : undefined;

export const loadMandantData =
  (): ThunkAction<void, MandantConfigState, any, any> =>
  // eslint-disable-next-line unicorn/consistent-function-scoping
  async (dispatch: Dispatch): Promise<void> => {
    dispatch(setLoading(true));
    // TODO: use better tenant default mechanism
    const tenant = gup('tenant') ?? tenantFallback;

    const search = tenant ? `?${new URLSearchParams({ tenant }).toString()}` : '';

    const path = `${getAPIPath(
      'advisory-excellence-portal',
    )}/home/api/customers/config/v1/mandantconfig${search}`;

    let responseData;

    try {
      const response = await fetchWrapper(getConnection(), path, {
        method: 'GET',
      });
      if (response.ok) {
        responseData = await response.json();
      }
    } catch {
      console.error('Could not fetch mandantConfig.');
    }

    const clientIdent =
      responseData?.tenantCode === null ? 'interhyp.home' : `${responseData?.tenantCode}.home`;
    const xsrfToken = getCookie('XSRF-TOKEN');

    const client = new ApolloClient({
      uri: `${getAPIPath('content')}/api/graphql`,
      request: operation => {
        operation.setContext({
          headers: {
            'x-xsrf-token': xsrfToken,
          },
        });
      },
    });

    // TODO: if mandant capability is live we need to change the behavior here that the query can be called without tenant query parameter!
    const result = await client.query({
      fetchPolicy: 'no-cache',
      query: gql`{
          global: publishedContentsByLanguageAndContext(language: "de", context: "global"),
          neutral: publishedContentsByLanguageAndContext(language: "de", context: "neutral.home"),
          neutralHome: publishedContentsByLanguageAndContext(language: "de", context: "neutralHome"),
          interhypHome: publishedContentsByLanguageAndContext(language: "de", context: "interhypHome"),
          tenant: publishedContentsByLanguageAndContext(language: "de", context: "${clientIdent}")
        }`,
    });
    dispatch(
      setTranslation({ ...result.data.global, ...result.data.neutral, ...result.data.tenant }),
    );
    dispatch(setLoading(false));
    dispatch(setData(responseData));
  };
